'use es6';

import { STARTER, PROFESSIONAL, ENTERPRISE } from 'self-service-api/constants/ProductLevels';
import { CRM_SUITE_STARTER, CRM_SUITE_PROFESSIONAL, CRM_SUITE_ENTERPRISE } from 'pricing-pages-unified-ui/constants/NonMerchandiseIdIdentifers'; // These are used ONLY to attach to nodes for acceptance test purposes

export default {
  [STARTER]: CRM_SUITE_STARTER,
  [PROFESSIONAL]: CRM_SUITE_PROFESSIONAL,
  [ENTERPRISE]: CRM_SUITE_ENTERPRISE
};